import React from 'react';
import { connect } from 'react-redux';
import './style.css';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import { Table } from 'antd';
import { fetchMySalary } from '../../actions/employee-actions';

class MySalary extends React.Component {
	componentWillMount() {
		this.props.fetchMySalary();
	}
	columns = [{
		title:<div style={{textAlign:'center'}}>年月<br/>Year/Month</div>,
	key: "account_monthly",
	dataIndex: "account_monthly",
	className: 'table-global-head',
	align: 'center'
},{
	title: <div style={{textAlign:'center'}}>我的薪资<br/>Gross<br/> Salary</div>,
	key: "current_base_salary",
	dataIndex: "current_base_salary",
	className: 'table-global-head',
	align: 'center'
},{
	title: <div style={{textAlign:'center'}}>岗位工资<br/>Post<br/>Salary</div>,
	key: "current_post_salary",
	dataIndex: "current_post_salary",
	className: 'table-global-head',
	align: 'center'
},
{
	title: <div style={{textAlign:'center'}}>课时费<br/>Class<br/>Fee</div>,
	key: "class_hour_fee",
	dataIndex: "class_hour_fee",
	className: 'table-global-head',
	align: 'center'
},
{
	title: <div style={{textAlign:'center'}}>固定津贴<br/>Fixed<br/>Allowance</div>,
	key: "fixed_allowance",
	dataIndex: "fixed_allowance",
	className: 'table-global-head',
	align: 'center'
},
{
	title: <div style={{textAlign:'center'}}>补贴<br/>Subsidy</div>,
	key: "welfare_subsidies",
	dataIndex: "welfare_subsidies",
	className: 'table-global-head',
	align: 'center'
},
{
	title: <div style={{textAlign:'center'}}>其他补贴<br/>Other<br/>Subsidy</div>,
	key: "subsidy",
	dataIndex: "subsidy",
	className: 'table-global-head',
	align: 'center'
},
{
	title: <div style={{textAlign:'center'}}>全勤奖<br/>Full-Attendance <br/>Bonus  </div>,
	key: "full_attendance_bonus",
	dataIndex: "full_attendance_bonus",
	className: 'table-global-head',
	align: 'center'
},
{
	title: <div style={{textAlign:'center'}}>事假<br/>Personal <br/>Leave </div>,
	key: "leave_subsidies",
	dataIndex: "leave_subsidies",
	className: 'table-global-head',
	align: 'center'
},{
	title: <div style={{textAlign:'center'}}>病假<br/>Sick <br/>Leave </div>,
	key: "sick_leave_subsidies",
	dataIndex: "sick_leave_subsidies",
	className: 'table-global-head',
	align: 'center'
},
{
	title: <div style={{textAlign:'center'}}>未打卡<br/>No <br/>Clock-In/Out </div>,
	key: "not_punched_deduct",
	dataIndex: "not_punched_deduct",
	className: 'table-global-head',
	align: 'center'
},
{
	title: <div style={{textAlign:'center'}}>迟到<br/>Tardiness </div>,
	key: "come_late_deduct",
	dataIndex: "come_late_deduct",
	className: 'table-global-head',
	align: 'center'
},{
	title: <div style={{textAlign:'center'}}>旷工扣款<br/>No <br/>Absenteeism </div>,
	key: "stay_away_deduct",
	dataIndex: "stay_away_deduct",
	className: 'table-global-head',
	align: 'center'
},
{
	title: <div style={{textAlign:'center'}}>社保个人<br/>Social  <br/>Insurance </div>,
	key: "social_securitys_personal",
	dataIndex: "social_securitys_personal",
	className: 'table-global-head',
	align: 'center'
},{
	title: <div style={{textAlign:'center'}}>公积金个人<br/>Housing   <br/>Fund </div>,
	key: "provident_fund_rates_personal",
	dataIndex: "provident_fund_rates_personal",
	className: 'table-global-head',
	align: 'center'
},{
	title: <div style={{textAlign:'center'}}>个税<br/>Income <br/>Tax  </div>,
	key: "withholding_tax",
	dataIndex: "withholding_tax",
	className: 'table-global-head',
	align: 'center'
},{
	title: '税后扣款',
	dataIndex: 'post_tax_deduct',
	key: 'post_tax_deduct',
	className: 'table-global-head-short'
},
{
	title: '子女教育支出',
	dataIndex: 'children_education',
	key: 'children_education',
	className: 'table-global-head',
	align: 'center'
}, {
	title: '住房贷款利息支出',
	dataIndex: 'home_loan_interest',
	key: 'home_loan_interest',
	className: 'table-global-head',
	align: 'center'
},{
	title: '继续教育支出',
	dataIndex: 'adult_education',
	key: 'adult_education',
	className: 'table-global-head',
	align: 'center'
},  {
	title: '住房租金支出',
	dataIndex: 'housing_rents',
	key: 'housing_rents',
	className: 'table-global-head',
	align: 'center'	
}, {
	title: '赡养老人支出',
	dataIndex: 'support_the_old',
	key: 'support_the_old',
	className: 'table-global-head',
	align: 'center'
},{
	title: <div style={{textAlign:'center'}}>实发工资<br/>Net   <br/>Salary </div>,
	key: "real_wages",
	dataIndex: "real_wages",
	className: 'table-global-head',
	align: 'center'
},
{
	title: '缴纳单位',
	dataIndex: 'pay_unit',
	key: 'pay_unit',
	className: 'table-global-head',
	align: 'center'
},


]
	fetchMySalary = pagination => {
		this.props.fetchMySalary({page: pagination.current});
	}
	render() {
		return (
			<div className="app-module-item">
				<div className="Attendanceholiday">我的薪资 My Salary</div>
				<div style={{paddingTop:"20px", paddingBottom:"20px"}}>
					<Table columns={this.columns}
						dataSource={this.props.employee.mySalaryData}
						pagination={{total: this.props.employee.mySalaryTotalPage,
							defaultCurrent: 1,
							pageSize: this.props.employee.mySalaryPageSize,
							current: this.props.employee.mySalaryPage}}
						scroll={{x: 1010}}
						onChange={this.fetchMySalary.bind(this)}
						rowKey={record => record.id} 
					 />					
				</div>
			</div>
		)
	}
}
const mapStateToProps = state => {
	return {
		employee: state.employee
	}
}

const mapDispatchToProps = {
	fetchMySalary
}


export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(MySalary));


// WEBPACK FOOTER //
// ./src/routes/Employee/MySalary.js